import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Label,
} from "reactstrap";


// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";

import showNotification from "../../../../helpers/show_notification";
import { ExportAvailableInCSVForReports, formatUnitsForReport, MapAllObjectUnits, MapTotalForArrangement, MapUnitForArrangement } from "../../../../helpers/units";
import preloader from "../../../../helpers/preloader";
import ReactSelect from "react-select";

const ProductCategoryDriverArrangementReport = (props) => {

  useEffect(() => {
    loadAllTimeStamps();
    loadAllVehicles();
    loadAllCategories();
  }, []);

  const [allTimeStamps, setAllTimeStamps] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState();
  const [selectedCategory, setselectedCategory] = useState();
  const [selectedTimestamp, setSelectedTimestamp] = useState();
  const loadAllTimeStamps = async () => {
    let url =
      process.env.REACT_APP_BASEURL + "productorders/get_arrangement_marks";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllTimeStamps(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  useEffect(() => {
    loadProducts();
  }, [selectedTimestamp,selectedVehicle,selectedCategory]);

  const [data, setData] = useState([]);
  const loadProducts = async () => {
    try {
      preloader(true)
      let data_to_send = {
        mark_time:selectedTimestamp && selectedTimestamp !== ""? selectedTimestamp
            : null,
            vehicle_id: selectedVehicle?._id,
            category:selectedCategory?.value
      };
      let url = process.env.REACT_APP_BASEURL + "productorders/category_vehicle_arrangement_report";
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        setData(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false)
    }
  };

  const [allCategories, setAllCategories] = useState([]);
  const loadAllCategories = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "productsections/getall_categories";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const transformedData = response.data.map(item => {
        return {
          ...item,
          label: item.category,
          value: item.category,
        };
      });
      preloader(false)
      setAllCategories(transformedData);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
  };

  const [allVehicles, setAllVehicles] = useState([]);
  const loadAllVehicles = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "vehicles/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const transformedData = response.data.map(item => {
        return {
          ...item,
          label: item.name,
          value: item._id,
        };
      });
      preloader(false)
      setAllVehicles(transformedData);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
  };

  const getColumns = (values) => {
    const columns = [
      { dataField: "_id", hidden: true },
      //{ dataField: "prod", text: "Product Name" },
    ];


    for (let key in values[0]) {   
      if( key === "Total"){
        columns.push({
          text: key,
          dataField: key,
          formatter: (cell, row, rowIndex) => {
            return ( MapTotalForArrangement(cell) );
          },
        });
      } else{
        if (key !== "Product Name") {
          columns.push({
            text: key,
            dataField: key,
            formatter: (cell, row, rowIndex) => {
              return ( MapAllObjectUnits(cell) );
            },
          });
        }else{
          columns.push({
            text: key,
            dataField: key,
          });
        }
      }
     
    }
    return columns;
  };
  function printDiv(divName) {
    let printContents = document.getElementById(divName).innerHTML;

    var winPrint = window.open(
      "",
      "",
      "left=0,top=0,toolbar=0,scrollbars=0,status=0"
    );
    // winPrint.document.body.innerHTML = printContents;
    winPrint.document.write(
      `<title>${divName} Report</title>
      <head>
        <style>
          table {
            table-layout: fixed;
            font-family: "Poppins", sans-serif;
            border: 1px solid #eff2f7;
            font-size: 12px;
            border-collapse: collapse;
            width: 100%;
            color: #495057;
            margin-bottom: 1rem;
            margin-top: 1rem;
          }
          
          for-print-heading {
            font-size: 16px;
            margin: 0 0 7px 0;
            font-weight: bold;
          }

          for-print-sub_heading {
            font-size: 14px;
            margin: 0 0 7px 0;
            font-weight: normal !important;
          }

          table td, table th {
            border: 1px solid #ddd;
            padding: 8px;
          }
          
          table tr:nth-child(even){background-color: #f2f2f2;}
          
          table tr:hover {background-color: #ddd;}
          
          table th {            
            text-align: left;
          }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
      `
    );
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    //winPrint.close();
  }

  const handleDownload2 = (data) => {
    const exportData = [];
    // Process each category
    data.forEach((categoryData) => {
      const categoryName = categoryData.category || " ";

      // Dynamically extract all branch keys from products
      const branchKeys = new Set();
      categoryData.products.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key !== "Product Name" && key !== "Total") {
            branchKeys.add(key);
          }
        });
      });
      const branchArray = Array.from(branchKeys);

      // Add category header row with branches
      const headerRow = { "Product Name": `<strong> ${categoryName} </strong>`};
      branchArray.forEach((branch) => {
        headerRow[branch] = '';
      });
      headerRow["Total"] = "";
      headerRow["Unit"] = "";
      exportData.push(headerRow);

      // Process each product
      categoryData.products.forEach((item) => {
        const itemRow = { "Product Name": item["Product Name"] };
        // Fill branch data
        branchArray.forEach((branch) => {
          if (item[branch] && Object.keys(item[branch]).length > 0) {
            const branchUnits = Object.entries(item[branch])
              .map(([unit, quantity]) => `${quantity}`)
              .join(", ");
            itemRow[branch] = branchUnits;
          } else {
            itemRow[branch] = "";
          }
        });

        // Handle Total column
        if (item.Total && Object.keys(item.Total).length > 0) {
          const totalUnits = Object.entries(item.Total)
            .map(([unit, quantity]) => `${quantity}`)
            .join(", ");
          itemRow["Total"] = totalUnits;

          // Add Unit column
          itemRow["Unit"] = Object.keys(item.Total).join(", ");
        } else {
          itemRow["Total"] = "";
          itemRow["Unit"] = "";
        }

        exportData.push(itemRow);
      });

      // Add an empty row for spacing
      exportData.push({});
    });
    const fileName = getReportName();
    const exportType = "xls";
    exportFromJSON({ data: exportData, fileName, exportType });
  };

  function getReportName (){
    let name = ""
    if(selectedVehicle && selectedCategory){
      name= `${selectedVehicle?.label} ${selectedCategory?.label} ARRANGEMENT`
      return name.toUpperCase();
    }
    else if(selectedCategory){
      name= `${selectedCategory?.label} ARRANGEMENT`
      return name.toUpperCase();
    }
    else if(selectedVehicle){
      name= `${selectedVehicle?.label} ARRANGEMENT`
      return name.toUpperCase();
    }
    else{
     return name = "TOTAL ARRANGEMENT"
    }
  }


  function printPage() {
    const containerElement = document.getElementsByClassName("printableArea")[0];
    const style = document.createElement("style");
    style.innerHTML = `
      .table thead th {
        color: #000 !important; 
        -webkit-print-color-adjust: exact; 
      }     
    `;
    document.head.appendChild(style);
    containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  
    setTimeout(() => {
      window.print();
      document.head.removeChild(style);
    }, 500);
  }
  return (
    <>
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumb_2Items
              alternateTitle={props.t("Product Category/Driver Arrangement Report")}
              title={props.t("Reports")}
              breadcrumbItem1={props.t("Orders")}
              breadcrumbItem2={props.t("Category/Driver Arrangement Report")}
            />
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <AvForm>
                      <Row>
                        <Col lg={4} md={4} sm={4}>
                          <AvField
                            name="timestamp"
                            label={props.t("Timestamp")}
                            value={selectedTimestamp}
                            type="select"
                            onChange={(e) =>
                              setSelectedTimestamp(e.target.value)
                            }
                          >
                            <option value="">{props.t("Latest")}</option>
                            {allTimeStamps &&
                              allTimeStamps.map((e) => (
                                <option key={e._id} value={e.mark_time}>
                                  {moment(e.mark_time).format(
                                    "DD/MM/YYYY HH:mm"
                                  )}
                                </option>
                              ))}
                          </AvField>
                        </Col>
                        <Col lg={4} md={4} sm={4}>
                        <Label>{props.t("Vehicle/Driver")}</Label>
                        <ReactSelect
                          name="location"
                          options={allVehicles}
                          isClearable={true}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={selectedVehicle}
                          onChange={setSelectedVehicle}
                          placeholder={props.t("Select Vehicle/Driver")}
                        />
                      </Col>
                      <Col lg={4} md={4} sm={4}>
                        <Label>{props.t("Category")}</Label>
                        <ReactSelect
                          name="category"
                          options={allCategories}
                          isClearable={true}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={selectedCategory}
                          onChange={setselectedCategory}
                          placeholder={props.t("Select Category")}
                        />
                      </Col>
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
           
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                   
                    <div className="printableArea">
                    <Row>
                      <Col lg={2} md={2} sm={2}>

                        <div className="d-print-none" >
                          <Link
                            to="#"
                            onClick={() => {printPage()}}
                            className="btn btn-success waves-effect waves-light"
                          >
                            <i className="fa fa-print"></i>&nbsp;Print Report
                          </Link>
                        </div>
                      </Col>
                      <Col lg={8} md={8} sm={8} >
                        <h3 className="text-center">Category/Driver Arrangement Report</h3>
                      </Col>
                     
                      <Col lg={2} sm={2} md={2} className="d-print-none">
                        <div className="float-right d-print-none">
                          <Button
                            type="submit"
                            className="btn btn-secondary"
                            onClick={() => {
                              handleDownload2(data || []);
                            }}
                          >
                            <i className="mdi mdi-file-export"></i>&nbsp;
                            {props.t("Export CSV")}
                          </Button>
                        </div>

                      </Col>

                    </Row>
                      {/* <h3 className="text-center">Category/Driver Arrangement Report</h3> */}
                      <hr />
                      {data &&
                        data.map((section) => {
                          return (
                            <>
                              {/* <div className="d-print-none">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    printDiv(section.category);
                                  }}
                                  className="btn btn-sm btn-success mr-2"
                                >
                                  <i className="fa fa-print"></i> Print Category
                                </Link>
                              </div>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-sm btn-secondary"
                                  onClick={() => {
                                    handleDownload2([section]);
                                  }}
                                >
                                  <i className="mdi mdi-file-export"></i>
                                  {props.t("Export CSV")}
                                </Button>
                              </div> */}
                              <div id={section.category}>
                                <CardTitle className="for-print-heading">
                                  {section.category}
                                </CardTitle>

                            
                                      <div
                                        style={{
                                          overflowX: "scroll",
                                        }}
                                      >
                                        <ToolkitProvider
                                          bootstrap4
                                          keyField="_id"
                                          data={section.products && section.products}
                                          columns={getColumns(section.products)}
                                          noDataIndication={props.t(
                                            "No data to display."
                                          )}
                                          search
                                          exportCSV
                                        >
                                          {(props) => (
                                            <BootstrapTable
                                              striped
                                              hover
                                              condensed
                                              {...props.baseProps}
                                            />
                                          )}
                                        </ToolkitProvider>
                                      </div>
                                      <br />
                          
                                <hr />
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ProductCategoryDriverArrangementReport))
);
